import apiClient from "./apiClient";

// Utility function to send POST request
const postData = async (url, params) => {
    const formData = new URLSearchParams();
    for (const key in params) {
        formData.append(key, params[key]);
    }
    return apiClient.post(url, formData);
};

export const signInApi = (params) => postData("/user/services/openapi", params);
export const signOutApi = (params) => postData("/user/services/openapi", params);
export const eventSlotListApi = (params) => postData("/user/services/api", params);
export const eventInfoApi = (params) => postData("/user/services/api", params);
export const scanTicketApi = (params) => postData("/user/services/api", params);
export const oAuthSigninApi = (params) => postData("/user/services/openapi", params);
export const getActivationURLApi = (params) => postData("/user/services/mfa", params);
export const verifyOTPApi = (params) => postData("/user/services/mfa", params);
export const isUserLoggedInApi = (params) => postData("/user/services/api", params);
export const getHostDomainImagesApi = (params) => postData("/user/services/openapi", params);